module.exports = __webpack_public_path__ + "static/media/download.869031aa.svg";